// @flow

import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { type Props } from '.';
import Dao from '../../components/dao';
import MembershipNoModal from '../../components/modals/membership-no';
import PrsLinks from '../../components/prs-links/prslinks';
import './home.scss';


class Home extends Component<Props> {
  imageNumber: number = Math.floor(Math.random() * 6 + 1);

  imageStyle: '50%';

  props: Props;

  constructor() {
    super();
    this.openMembershipModal = this.openMembershipModal.bind(this);
  }

  openMembershipModal(event) {
    const { openMembershipModal } = this.props;
    openMembershipModal();
    event.nativeEvent.stopImmediatePropagation();
  }

  renderAuthenticated() {
    const { user } = this.props;
    const isMobileConfigEnabled = true;


    return (
      <div className="landing_page">
        <h1>
          Welcome back,
          <br />
          <span className="lime">{user.shortName}</span>
        </h1>
        {this.renderLoggedInAs()}
        <h2>Membership no. (CAE / IPI)</h2>
        <p>
          {user.cae}
          <button
            type="button"
            className="prs-icon prs-icon-info clickable landing_page--membership-info-icon"
            onClick={this.openMembershipModal}
          />
        </p>
        {user.isDaoUser ? <Dao /> : null}
        <NavLink to="/schedule" className="landing_page__payment_dates d-flex flex-row align-items-center">
          <span className="prs-icon prs-icon-calendar lime" />
          Payment dates
        </NavLink>
        {user.isSodUser ? (
          <React.Fragment>
            <hr />
            <div className="addtional_links">
              <a href="#/myworks">
                <div>
                  <span className="prs-icon prs-icon-my-works" />
                  <p>My works</p>
                </div>
              </a>
              <a href="#/search">
                <div>
                  <span className="prs-icon prs-icon-search" />
                  <p>Works</p>
                </div>
              </a>
              {isMobileConfigEnabled && <PrsLinks />}
            </div>
          </React.Fragment>
        ) : null}
      </div>
    );
  }

  renderLoggedInAs() {
    const { user } = this.props;
    if (user.profiles.length > 1) {
      return (
        <React.Fragment>
          <h2>Logged in as</h2>
          <p>
            {user.name}
          </p>
        </React.Fragment>
      );
    }
    return null;
  }

  render() {
    return (
      <div className="transition-item">
        <MembershipNoModal />
        <section className="container main-content">
          {this.renderAuthenticated()}
        </section>
      </div>
    );
  }
}

export default Home;
